import FlipCountdown from '@rumess/react-flip-countdown';

import './TimerFlip.css';

const TimerFlip = (props) => {
  return <FlipCountdown
    endAt={props.endDate}
    size='small'
    theme='dark'
    titlePosition='bottom'
    hideYear
    hideMonth
    dayTitle='روز'
    hourTitle='ساعت'
    minuteTitle='دقیقه'
    secondTitle='ثانیه' />
}

export default TimerFlip;